export default {
    loaded: ({vip20}) => vip20.loaded,
    level: ({vip20}) => vip20.level,
    level_preset: ({vip20}) => vip20.level_preset,
    tags: ({vip20}) => vip20.tags,
    xp: ({vip20}) => vip20.xp,
    bonuses: {
        freeplay: ({vip20}) => vip20.bonuses.freeplay,
        weekly_rakeback: ({vip20}) => vip20.bonuses.weekly_rakeback,
        random_boost: ({vip20}) => vip20.bonuses.random_boost,
        monthly_rakeback: ({vip20}) => vip20.bonuses.monthly_rakeback,
        birthday_bonus: ({vip20}) => vip20.bonuses.birthday_bonus,
        deposit_assist_token: ({vip20}) => vip20.bonuses.deposit_assist_token,
    },
    buttons: {
        freeplay: ({vip20}) => vip20.buttons.freeplay,
        birthday_bonus: ({vip20}) => vip20.buttons.birthday_bonus
    }
}